
define('text!templates/appMain/privilegedMain/qm/policies/editors/queueSelectorNameList.html',[],function () { return '<!-- ko foreach: queues -->\n<div class="queue-name" data-bind="text: name"></div>\n<!-- /ko -->';});

